import moment from 'moment'
import { createAverages } from './driverAnalyticAverages'
import { chartColors, hierarchyItems } from './constants'
import { formatters } from '@utils/intl/dateTimeFormatters'

export const existentAnalyticsItems = (n) => typeof n !== 'undefined' && n !== null

export const getCurrentDataSet = (viewMetricBy, drivers) => {
  const {
    [hierarchyItems.DEPOTS]: depots,
    [hierarchyItems.SUPERVISORS]: supervisors,
    [hierarchyItems.MARKETS]: markets,
    [hierarchyItems.SYSTEM]: system,
  } = createAverages(drivers)

  if (viewMetricBy === hierarchyItems.DRIVERS) {
    return {
      baseDataSet: drivers,
      baseDateKey: 'period_date',
      averageSet: depots,
      comparisonKey: `${hierarchyItems.DEPOTS}_name`,
    }
  } else if (viewMetricBy === hierarchyItems.DEPOTS) {
    return {
      baseDataSet: depots,
      baseDateKey: 'date',
      averageSet: supervisors,
      comparisonKey: `${hierarchyItems.SUPERVISORS}_name`,
    }
  } else if (viewMetricBy === hierarchyItems.SUPERVISORS) {
    // return {
    //   baseDataSet: supervisors,
    //   baseDateKey: 'date',
    //   averageSet: markets,
    //   comparisonKey: `${hierarchyItems.MARKETS}`,
    // }
    return {
      baseDataSet: supervisors,
      baseDateKey: 'date',
      averageSet: system,
      comparisonKey: 'system',
    }
  }

  return { baseDataSet: markets, baseDateKey: 'date', comparisonKey: 'system', averageSet: system }
}

export const createBarData = (
  names,
  dataPoints,
  selectedMetricType,
  selectedMetric,
  comparisonDataPoints,
  comparisonKey
) => {
  const dateKey = comparisonKey === 'depot_name' ? 'period_date' : 'date'
  const filteredDataPoints = dataPoints.filter(existentAnalyticsItems).filter((point) => names.includes(point?.name))
  const colorAdded = names.map((name, index) => ({ name, color: chartColors[index] }))
  const groups = filteredDataPoints.reduce((groups, item) => {
    const group = groups[item[dateKey]] || []
    group.push(item)
    groups[item[dateKey]] = group
    return groups
  }, {})

  const chartData = []
  let max = 0
  const averageName = filteredDataPoints[0][comparisonKey]
  for (const [key, value] of Object.entries(groups)) {
    const dateValues = { date: formatters.DATE(moment(key)) }
    value.forEach((item, index) => {
      const comparisonValue = comparisonDataPoints.find(
        (point) => point?.date === key && (comparisonKey === 'system' || point?.name === averageName)
      )
      if (comparisonValue) {
        dateValues.comparisonValue = comparisonValue[selectedMetricType][selectedMetric]
        if (dateValues.comparisonValue > max) {
          max = dateValues.comparisonValue
        }
      } else {
        dateValues.comparisonValue = 0
      }
      dateValues[item?.name] = item[selectedMetricType][selectedMetric]
      if (dateValues[item?.name] > max) {
        max = dateValues[item?.name]
      }
      dateValues[`${item?.name}Color`] = colorAdded.find((colors) => item?.name === colors.name)?.color
    })
    chartData.push(dateValues)
  }

  return { data: chartData.sort((a, b) => (moment(a.date).isBefore(b.date) ? -1 : 1)), max: max }
}

export const createMetricRows = (names, recentData, dataPoints, selectedMetricType, selectedMetric) => {
  const metricRows = []
  names.forEach((name) => {
    const filteredDataPoints = dataPoints.filter(existentAnalyticsItems).filter((point) => name === point?.name)
    const recent = recentData.find((row) => row?.name === name)
    const total = []
      .concat(...filteredDataPoints)
      .map((row) => row[selectedMetricType][selectedMetric])
      .reduce((a, b) => a + b)
    var avg = total / filteredDataPoints.length
    metricRows.push({
      name: name,
      recent: recent[selectedMetricType][selectedMetric],
      average: avg,
    })
  })
  return metricRows
}
export const createComparisonRow = (recentRow, dataPoints, selectedMetricType, selectedMetric) => {
  const filteredDataPoints = dataPoints
    .filter(existentAnalyticsItems)
    .filter((point) => recentRow?.name === point?.name)

  const total = []
    .concat(...filteredDataPoints)
    .map((row) => row[selectedMetricType][selectedMetric])
    .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
  var avg = total / filteredDataPoints.length

  // wtf is this lol.
  if (!recentRow) return { name: '', recent: '', average: '' }

  return {
    name: recentRow?.name,
    recent: recentRow[selectedMetricType][selectedMetric],
    average: avg,
  }
}

export const getRecents = (list, property) => {
  const _list = list.filter(existentAnalyticsItems)
  const dates = _list?.map((item) => new Date(item[property]))
  const minimumDate = new Date(Math.max.apply(null, dates))
  const filteredList = _list.filter((item) => {
    const jsDate = new Date(item[property])
    return jsDate.toISOString() === minimumDate.toISOString()
  })
  filteredList.forEach((item, i) => {
    item.sparkline = Array.from({ length: 20 }, () => Math.random() * (1.0 - 0.6) + 0.6)
    item.sparklineDifference = (item.sparkline[19] - item.sparkline[0]) * 20
  })

  return filteredList.filter((item) => !item.dataStub)
}

export const metricOptionSet = {
  productivity: [
    {
      display: 'Orders',
      value: 'orders',
    },
    {
      display: 'Stops',
      value: 'stops',
    },
    { value: 'total_miles', display: 'Total Distance' },
    { value: 'loaded_miles', display: 'Loaded Distance' },
    {
      display: 'Utilization %',
      value: 'utilization',
    },
    { value: 'miles_est_act_diff', display: 'Distance (Est/Act)' },
    { value: 'driving_time', display: 'Driving Time' },
    // { value: 'driving_time_diff', display: 'Driving Time (Est/Act)' },
    // { value: 'loading_time', display: 'Loading Time' },
    // { value: 'loading_est_act_diff', display: 'Loading Time (Est/Act)' },
    // { value: 'dropping_time', display: 'Dropping Time' },
    // { value: 'dropping_est_act_diff', display: 'Dropping Time (Est/Act)' },
    { value: 'loaded_volume', display: 'Loaded Volume' },
  ],
  accuracy: [
    { value: 'mispulls', display: 'Mispull %' },
    { value: 'loaded_vs_standard_gal', display: '% Volume v. Standard' },
  ],
}
